var React = require('react');

function ContentInfo (props) {
    return React.createElement("svg",props,[React.createElement("circle",{"fill":"none","stroke":"currentColor","strokeMiterlimit":"10","cx":"17.5","cy":"17.5","r":"15.66","key":0}),React.createElement("path",{"d":"M18.87,12.88h-2.73v-2.25h2.73v2.25ZM16.13,14.42h2.73v9.95h-2.73v-9.95Z","key":1})]);
}

ContentInfo.defaultProps = {"id":"other","viewBox":"0 0 35 35"};

module.exports = ContentInfo;

ContentInfo.default = ContentInfo;
